<template>
  <div class="table-responsive">
    <table class="table table-striped table-vcenter">
      <thead>
        <tr>
          <th width="10%">上报人</th>
          <th class="text-center">井号</th>
          <th class="text-center">井队</th>
          <th class="text-center">钻进周期（天）</th>
          <th class="text-center">钻头序列号</th>
          <th class="text-center">钻进状态</th>
          <th class="text-center">所属日期</th>
          <th class="text-center">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="report in list" :key="report.id">
          <td>{{ report.user.name }}</td>
          <td class="text-center">{{ report.project.pit_number }}</td>
          <td class="text-center">{{ report.project.pit_team }}</td>
          <td class="text-center">{{ report.work_day }}</td>
          <td class="text-center">
            <DrillLink :no="report.drill_number"></DrillLink>
          </td>
          <td class="text-center">
            {{ ReportDrillStatusMap[report.drill_status] }}
          </td>
          <td class="text-center">
            {{ $time(report.created_at).format('YYYY-MM-DD') }}
          </td>
          <td class="text-center">
            <el-button
              v-code="24103"
              type="text"
              size="mini"
              @click="$router.push(`/report/reports/${report.id}/edit`)"
              >编辑</el-button
            >
            <el-button
              v-code="24102"
              type="text"
              size="mini"
              @click="$router.push(`/report/reports/${report.id}`)"
              >详情</el-button
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ReportDrillStatusMap } from '@/config/global'
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ReportDrillStatusMap,
    }
  },
}
</script>